// dependencies
import { Map } from "immutable";
import { replace } from "yarrr";
import { GenerateProcess } from "redux-process";

// ui
import ui from "./ui";

// actions
import { changePageUI as updateUI } from "Actions/ui";

// selectors
import { getUI } from "Selectors/ui";
import { getPageSize, getSkipCount, getSearchInput } from "./selectors";

/**
 * Queries for companies, update the state
 */
export const queryCompanies = () => async (dispatch, getState) => {
	// parse state
	const state = getState();
	const skip = getSkipCount(state);
	const limit = getPageSize(state);
	const searchInput = getSearchInput(state);

	// request
	const request = await dispatch(GenerateProcess("CompaniesSearch", { limit, skip, q: searchInput }));

	// update ui
	const response = Map({
		count: request.response.get("count"),
		companies: request.response.get("companies"),
	});

	const currentUI = getUI(getState()).setIn(["cachedResponses", searchInput], response);
	dispatch(updateUI([], currentUI));
};

/**
 * Changes the current page
 *
 * @param {number} page - page to change to
 */
export const changePage = (page) => async (dispatch, getState) => {
	const state = getState();
	const searchInput = getSearchInput(state);

	dispatch(replace(`/companies/?q=${searchInput}&page=${page}`));
	dispatch(queryCompanies());
};

/**
 * Updates the search string.
 * Will reset the current page and dispatch a new query
 *
 * @param {string} value - next value of the search input
 */
export const updateSearch = (value) => async (dispatch) => {
	dispatch(replace(`/companies/?q=${value}&page=${1}`));

	// dispatch new query
	dispatch(queryCompanies());
};

/**
 * Fetch (or refetch) the data
 */
export const fetchPageData = () => async (dispatch) => {
	dispatch(queryCompanies());
};

/**
 * Initialize page.
 */
export const init = () => (dispatch) => {
	// set the initial UI
	const initialUI = ui;
	dispatch(updateUI([], initialUI));

	// fetch page data
	dispatch(fetchPageData());
};
